import { render, staticRenderFns } from "./customerUser.vue?vue&type=template&id=db31d476&scoped=true&"
import script from "./customerUser.vue?vue&type=script&lang=js&"
export * from "./customerUser.vue?vue&type=script&lang=js&"
import style0 from "./customerUser.vue?vue&type=style&index=0&id=db31d476&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db31d476",
  null
  
)

export default component.exports